import API_URL from '../apiconfig';
import {
  AutomationListItem,
  AutomationRecipeConfig,
  CreateAutomationRequest,
  RecipeTemplateRequest,
} from '../types/marketing/automations';
import { CreateTemplateAndEmbedResponse } from '../types/marketing';
import axios from './api';
import { getApiErrorMessage } from './apiError';
import client from '../utils/react-query/client';

export async function getAutomations(marketingBusinessId: string) {
  try {
    const result = await axios.get(`${API_URL}/v1/automations`, {
      params: { marketingBusinessId },
    });
    return result.data.result as AutomationListItem[];
  } catch (error) {
    throw new Error('Cannot get automations', { cause: error });
  }
}

export async function getAutomationRecipes() {
  try {
    const result = await axios.get(`${API_URL}/v1/automations/recipes`);
    return result.data.result as AutomationRecipeConfig[];
  } catch (error) {
    throw new Error('Cannot get automation recipes', { cause: error });
  }
}

export async function createAutomation(body: CreateAutomationRequest) {
  try {
    await axios.post(`${API_URL}/v1/automations`, body);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Cannot create automation'), {
      cause: error,
    });
  }
}

export async function getOrCreateRecipeTemplate(body: RecipeTemplateRequest) {
  try {
    const result = await axios.post(
      `${API_URL}/v1/automations/recipe-template`,
      body,
    );
    return result.data.result as CreateTemplateAndEmbedResponse;
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Cannot load the recipe template'),
      { cause: error },
    );
  }
}

export async function pauseAutomation(automationId: string) {
  try {
    await axios.post(`${API_URL}/v1/automations/${automationId}/pause`);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Cannot pause automation'), {
      cause: error,
    });
  }
}

export async function resumeAutomation(automationId: string) {
  try {
    await axios.post(`${API_URL}/v1/automations/${automationId}/resume`);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Cannot resume automation'), {
      cause: error,
    });
  }
}

export async function deleteAutomation(automationId: string) {
  try {
    await axios.delete(`${API_URL}/v1/automations/${automationId}`);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Cannot delete automation'), {
      cause: error,
    });
  }
}

export async function invalidateAutomations() {
  await client.invalidateQueries({
    queryKey: ['marketing-automations'],
    exact: false,
  });
}
